export default __webpack_public_path__ + "static/media/List-documentation.8181771a.md";